import React from 'react';
import Typed from 'react-typed';
import locales from '../../locales/locales';

const AboutOne = () => {
  const { TITLE, TITLE_ENUMERARION, INDUSTRIES_TEXT, TEAM_TEXT } = locales;
    return (
        <div className="rwt-about-area rn-section-gap">
            <div className="container">
                <div className="row row--30 align-items-center">
                    <div className="col-lg-5">
                        <div className="thumbnail">
                            <img className="w-100" src="./images/about/about-1.png" alt="About Images" />
                        </div>
                    </div>

                    <div className="col-lg-7 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="section-title">
                                <h2 className="title">{TITLE} <br /> {" "}
                                    <Typed className="theme-gradient"
                                        strings={TITLE_ENUMERARION}
                                        typeSpeed={80}
                                        backSpeed={5}
                                        backDelay={1000}
                                        loop
                                    />
                                </h2>
                                <p>{INDUSTRIES_TEXT}</p>
                                <p>{TEAM_TEXT}</p>
                                <div className="read-more-btn mt--40">
                                    <a className="btn-default" href="/about"><span>Find more about us</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>   
        </div>
    )
}

export default AboutOne
